import React from 'react';
import { overNudge } from '../studioCounts';
import './StudioRecap.css';

// "How many videos" under the editor: one row of cells side by side — Original · Scripts · Concepts — then a Total cell, large and
// in accent. Cells at zero are dimmed, never hidden. Past 5 videos for one clip the Total turns amber and one line reminds the
// team of the taxonomy (a reminder, not a block). The numbers come from studioCounts.videoBreakdown, nothing is computed here.
export default function StudioRecap({ breakdown, compact = false }) {
  const b = breakdown;
  const over = overNudge(b.total);
  const cells = [['Original', b.original], ['Scripts', b.scripts], ['Concepts', b.concepts]];
  return (
    <div className={`srecap-wrap${compact ? ' srecap-wrap--compact' : ''}`}>
      <div className={`srecap${over ? ' srecap--over' : ''}${compact ? ' srecap--compact' : ''}`}>
        {cells.map(([k, c]) => (
          <div key={k} className={`srecap-cell${c.n ? '' : ' srecap-cell--off'}`}>
            <span className="srecap-k">{k}</span>
            <span className="srecap-v">{c.n}</span>
            <span className="srecap-d">{c.detail}</span>
          </div>
        ))}
        <div className="srecap-total">
          <span className="srecap-k">Total</span>
          <span className="srecap-v">{b.total}</span>
          <span className="srecap-d">video{b.total === 1 ? '' : 's'}</span>
        </div>
      </div>
      {over && (
        <div className="srecap-nudge" role="note">
          <b>{b.total} videos from one concept.</b> The taxonomy caps a concept at 2–3 variations, 5 with AI tools — past that it adds noise rather than signal. You can still go ahead.
        </div>
      )}
    </div>
  );
}
